
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"1920","height":"933"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-opacity":".04","fill-rule":"evenodd","d":"M1033.121 652.382v-9.015c253.976 0 280.138-26.21 280.138-280.187h9.064c0 253.976 26.162 280.187 280.187 280.187v9.015c-254.025 0-280.187 26.21-280.187 280.187h-9.064c0-253.976-26.162-280.187-280.138-280.187zm516.722-572.23c-7.74-13.228-15.53-24.889-23.271-34.981-7.741-10.093-16.903-18.421-27.387-25.035-10.484-6.614-23.075-11.464-37.871-14.55-14.747-3.136-33.364-4.655-55.9-4.655L1235.704 0c-22.536 0-41.202 1.568-55.9 4.654-14.796 3.087-27.387 7.937-37.871 14.551-10.484 6.614-19.646 14.943-27.387 25.035-7.79 10.092-15.53 21.753-23.271 34.98L712.27 714.946c-6.957 11.66-13.179 20.969-18.617 27.974-5.438 6.957-11.072 12.2-16.902 15.678-5.83 3.527-12.64 5.88-20.38 7.006-3.283.49-24.889.833-33.463.833H572.79c-12.395 0-22.487-.588-30.277-1.764-7.74-1.127-14.55-3.478-20.38-7.006-5.782-3.478-11.465-8.72-16.854-15.677-5.438-7.006-11.66-16.315-18.666-27.975L67.335 0H-140l510.157 852.613c7.74 13.228 15.53 24.888 23.271 34.932 7.79 10.092 16.903 18.47 27.387 25.084 10.484 6.565 23.124 11.415 37.871 14.55 14.747 3.087 33.364 4.655 55.9 4.655l169.71.93c22.536 0 41.202-1.567 55.9-4.703 14.796-3.086 27.436-7.936 37.871-14.501 10.484-6.614 19.646-14.992 27.387-25.084 7.79-10.044 15.53-21.704 23.32-34.932L1207.73 217.82c7.006-11.66 13.179-20.969 18.617-27.975 5.438-6.957 11.072-12.199 16.902-15.726 5.83-3.479 12.64-5.781 20.38-6.957 3.283-.49 24.889-.833 33.463-.833h50.119c12.395 0 22.536.588 30.277 1.764 7.74 1.175 14.55 3.478 20.38 6.957 5.782 3.527 11.465 8.77 16.903 15.726 5.39 7.006 11.611 16.315 18.617 27.975l419.326 714.014H2060L1549.843 80.15z"}})])
          )
        }
      }
    